export const validation = {
	badge: {
		validated: "Validado",
		pending: "Pendiente de validación",
		preExisting: "Preexistente",
	},
	filter: {
		label: "Estado",
		all: "Todos",
		pending: "Pendiente de validación",
		validated: "Validados",
	},
	banner: {
		title: "¡Tienes datos fiscales para validar!",
		message: "Confirma los datos para poder utilizar estos perfiles fiscales.",
	},
	card: {
		confirmAction: "Confirmar datos",
		validateAction: "Validar datos",
		viewDetails: "Ver detalles",
	},
	drawerNotice: {
		pendingValidation: "Valida los datos para usar este perfil fiscal",
		pendingValidationGroup: "Valida los datos para usar este grupo fiscal",
	},
	modalConfirm: {
		title: "Confirmar datos fiscales",
		message:
			"¿Seguro que deseas validar los datos de este perfil fiscal? Al confirmar quedará disponible para ser utilizado en el sistema.",
		confirm: "Confirmar datos",
		success: "¡Datos validados con éxito!",
	},
	modalReject: {
		title: "Rechazar datos fiscales",
		message:
			"¿Seguro que deseas rechazar estos cambios? El registro volverá al estado anterior.",
		confirm: "Confirmar rechazo",
		success: "Datos rechazados.",
	},
	infoBlock: {
		title: "Validación de datos fiscales",
		validatedAt: "Fecha/hora de la validación",
		validatedBy: "Validado por",
		newBadge: "Nuevo",
	},
	drawerFooter: {
		confirmData: "Confirmar datos",
		reject: "Rechazar",
	},
	form: {
		saveAndValidate: "Guardar y Validar",
		saveAndValidateSuccess: "Guardado y validado con éxito.",
	},
};
